import ReactDiffViewer from 'react-diff-viewer-continued';
import { ComponentProps } from '../layout-interfaces';
import { parseTemplate } from '../component-hooks';

export const DiffComponent = (props: ComponentProps) => {
  return (
    <div className={'diff-wrapper'}>
      <ReactDiffViewer
        oldValue={
          parseTemplate(props.props.oldValue, {
            ...props?.variables,
            ...props?.context?.store,
          }) ?? ''
        }
        newValue={
          parseTemplate(props.props.newValue, {
            ...props?.variables,
            ...props?.context?.store,
          }) ?? ''
        }
        splitView={true}
        leftTitle={
          parseTemplate(props.props.leftTitle, {
            ...props?.variables,
            ...props?.context?.store,
          }) ?? 'Old'
        }
        rightTitle={
          parseTemplate(props.props.rightTitle, {
            ...props?.variables,
            ...props?.context?.store,
          }) ?? 'New'
        }
      />
    </div>
  );
};
